import axios from 'axios'
import _ from 'lodash'
import { Auth } from 'aws-amplify'
import { clearState } from '@vp/legacy/shared/sessionStorage'
const MAX_TIMEOUT = 45000
export const baseUrl = '/api/legacy'
const promotionsUrl = '/api/promotions'
const generic = axios.create({ baseURL: baseUrl })
export const error = (info: any, meta: any) =>
  console.error('Network Request Failed', { info, ...meta })
export const event = async (info: any, meta: any) =>
  generic.post('/client/event', {
    info,
    ...meta,
  })
const handleIfTokenExpiry = (data: any) => {
  if (data.errorCode === '401.4') {
    clearState()
    window.location.href = process.env.SITE_URL || ''
  }
}
export const createApiClient = (options: any) => {
  const { ...axiosOptions } = options
  const api = axios.create({
    timeout: MAX_TIMEOUT,
    withCredentials: true,
    ...axiosOptions,
  })
  api.interceptors.request.use(
    async (config) => {
      try {
        await Auth.currentSession()
      } catch (_e) {
        // ignored: request may continue for unauthenticated paths
      }

      config.headers.set('Client-Name', 'Web')
      return config
    },
    (err) => Promise.reject(err),
  )
  api.interceptors.response.use(
    (response) => response,
    // eslint-disable-next-line @typescript-eslint/require-await
    async (err) => {
      let url
      let method
      let status
      let statusText
      let errorMessage = 'Unhandled API error'
      try {
        if (err && err.response) {
          const { data, request } = err.response
          handleIfTokenExpiry(data)
          errorMessage = data && data.errorMessage ? data.errorMessage : 'Unhandled API error'
          url = request ? request.responseURL : err.response.config.url
          method = err.response.config.method
          status = err.response.status
          statusText = err.response.statusText
        }
      } catch (e: any) {
        // Do nothing
      }
      error(errorMessage, { url, method, status, statusText, source: 'Web' })
      throw err
    },
  )
  return api
}
export const auth = createApiClient({
  baseURL: `${baseUrl}/auth`,
})
export const authV2 = createApiClient({
  baseURL: `${baseUrl}/2/auth`,
})
/**
 * @deprecated as it's missing latest auth middleware.
 * Alternatively use {@link clientImproved}
 */
export const client = axios.create({
  baseURL: `${baseUrl}/client`,
  withCredentials: true,
})
export const clientImproved = createApiClient({
  baseURL: `${baseUrl}/client`,
  type: 'user',
})
export const root = axios.create({
  baseURL: `${baseUrl}`,
  withCredentials: true,
})
export const clientV2 = createApiClient({
  baseURL: `${baseUrl}/2/client`,
  type: 'user',
})
export const clientV21 = createApiClient({
  baseURL: `${baseUrl}/2.1/client`,
  type: 'user',
})
export const vendor = createApiClient({
  baseURL: `${baseUrl}/vendor`,
  type: 'vendor',
})
export const supplierV2 = createApiClient({
  baseURL: `${baseUrl}/2/suppliers`,
  type: 'vendor',
})
export const promotionsVendor = createApiClient({
  baseURL: `${promotionsUrl}/`,
  type: 'vendor',
})
export const supplierV2public = createApiClient({
  baseURL: `${baseUrl}/2/public/suppliers`,
})
export const admin = createApiClient({
  baseURL: `${baseUrl}`,
  type: 'admin',
})
export const cron = createApiClient({
  baseURL: `${baseUrl}/2/cron`,
})
export const adminV2 = createApiClient({
  baseURL: `${baseUrl}/2/admin`,
  type: 'admin',
  timeout: 50000,
})
export const adminV21 = createApiClient({
  baseURL: `${baseUrl}/2.1/admin`,
  type: 'admin',
})
export const kioskUserV2 = createApiClient({
  baseURL: `${baseUrl}/2/kiosk`,
})
export const publicV2 = createApiClient({
  baseURL: `${baseUrl}/2/public`,
})
export const tagsV1 = createApiClient({
  baseURL: `${baseUrl}/tag-groups`,
})
export const aLaCalc = createApiClient({
  baseURL: `${baseUrl}/alacalc`,
})
export const menuPublishingAdmin = createApiClient({
  baseURL: '/api/menu-publishing',
  type: 'admin',
})
export const geocodingService = createApiClient({
  baseURL: '/api/geocoding',
})
// Add a request interceptor
// api.interceptors.request.use(
//  (config) => {
//   //Do something before request is sent
//    console.log(config.url, config);
//    return config;
//  },
//  error => Promise.reject(error),
// );
const errorHandling = (err: any) => Promise.reject(err.response)
export const setToken = (token: any) => {
  if (!token) {
    return
  }
  const headers = _.cloneDeep(client.defaults.headers)
  headers.common.Authorization = `Bearer ${token}`
  client.defaults.headers = headers
  client.defaults.headers.common.Authorization = `Bearer ${token}`
  client.interceptors.response.use(undefined, errorHandling)
  clientV2.defaults.headers = headers
  clientV2.defaults.headers.common.Authorization = `Bearer ${token}`
  clientV2.interceptors.response.use(undefined, errorHandling)
  clientV21.defaults.headers = headers
  clientV21.defaults.headers.common.Authorization = `Bearer ${token}`
  clientV21.interceptors.response.use(undefined, errorHandling)
  generic.defaults.headers = headers
  generic.defaults.headers.common.Authorization = `Bearer ${token}`
}
export const setVendorToken = (token: any) => {
  if (!token) {
    return
  }
  const headers = _.cloneDeep(vendor.defaults.headers)
  headers.common.Authorization = `Bearer ${token}`
  vendor.defaults.headers = headers
  vendor.defaults.headers.common.Authorization = `Bearer ${token}`
  supplierV2.defaults.headers = headers
  supplierV2.defaults.headers.common.Authorization = `Bearer ${token}`
  promotionsVendor.defaults.headers = headers
  promotionsVendor.defaults.headers.common.Authorization = `Bearer ${token}`
  generic.defaults.headers = headers
  generic.defaults.headers.common.Authorization = `Bearer ${token}`
}
